import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'bosch-logo',
  imports: [],
  templateUrl: './bosch-logo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bosch-logo.component.scss',
})
export class BoschLogoComponent {}
